import type { FC } from "react";

import {
  Button,
  ButtonGroup,
  Column,
  Dialog,
  Spinner,
  Text,
} from "@hightouch/htui";

import { Editor } from "src/components/editor";

type Props = {
  sql: string | undefined | null;
  loading: boolean;
  visible: boolean;
  onClose: () => void;
  onCopy: () => void;
};

export const TraitSqlPreviewDialog: FC<Props> = ({
  sql,
  loading,
  visible,
  onClose,
  onCopy,
}) => {
  return (
    <Dialog
      isOpen={visible}
      variant="info"
      width="xl"
      title="Transformed SQL"
      actions={
        <ButtonGroup>
          <Button isDisabled={loading} onClick={onCopy}>
            Copy SQL
          </Button>
          <Button variant="primary" onClick={onClose}>
            OK
          </Button>
        </ButtonGroup>
      }
      onClose={onClose}
    >
      {loading ? (
        <Column align="center" justify="center" height="100%">
          <Spinner size="lg" />
          <Text mt={4}>Fetching transformed SQL…</Text>
        </Column>
      ) : (
        <Editor readOnly language="sql" value={sql ?? ""} />
      )}
    </Dialog>
  );
};
